"use client";

import { useState } from "react";

import type { AccordionItem } from "./AccordionItems";

import AccordionItems from "./AccordionItems";

export default function AccordionItemsSingleExpand({
  items,
  initialIdx: initialIdx = 0,
}: {
  initialIdx?: number;
  items: AccordionItem[];
}) {
  const [selectedIdx, setSelectedIdx] = useState(initialIdx);
  const handleSelect = (idx: number) => {
    setSelectedIdx(idx);
  };
  return <AccordionItems items={items} onSelect={handleSelect} selectedIdx={selectedIdx} />;
}
